const ShippingDeliveryMethods = {
  IN_STORE: 'in_store',
  CUSTOMER_ADDRESS: 'customer_address',
  PICKUP: 'pickup',
  OTHER: 'other',
};

module.exports = ShippingDeliveryMethods;
